import { isMatchingLocale } from 'modules/projectSettings/utils';
import { useMemo, useState } from 'react';
import { useWhatsAppInfobipLocalesContext } from '../../LocalesList/WhatsAppInfobipLocalesContext';
import { useDebouncedEffect } from 'utils/hooks/useDebouncedEffect';

const CATEGORY_LABELS = {
  ALL: 'all',
  SUGGESTED: 'suggested',
};

export const useLocaleOptions = (locale: string) => {
  const { whatsAppInfobipLocales } = useWhatsAppInfobipLocalesContext();
  const [debouncedLocale, setDebouncedLocale] = useState(locale);

  useDebouncedEffect(() => setDebouncedLocale(locale), [locale], {
    debounceTimeout: 300,
    skipEffectOnMount: true,
  });

  const { options, categoryLabels } = useMemo(() => {
    const options = whatsAppInfobipLocales.map(({ label, value }) => ({
      label,
      value,
      categoryId: CATEGORY_LABELS.ALL,
      ...(isMatchingLocale(debouncedLocale, value) && {
        Suffix: 'Suggested',
        categoryId: CATEGORY_LABELS.SUGGESTED,
      }),
    }));

    return {
      options,
      categoryLabels: {
        ...(options.some((option) => option.categoryId === CATEGORY_LABELS.SUGGESTED) && {
          [CATEGORY_LABELS.SUGGESTED]: '',
        }),
        [CATEGORY_LABELS.ALL]: '',
      },
    };
  }, [debouncedLocale, whatsAppInfobipLocales]);

  return {
    options,
    categoryLabels,
  };
};
